import { adminState } from './admin.state';
import { adminActions } from './admin.actions';
import { adminMutations } from './admin.mutations';
import { Module } from 'vuex';
import { RootState } from '@/store/store';

export default {
  namespaced: true,
  state: adminState,
  actions: adminActions,
  mutations: adminMutations
} as unknown as Module<typeof adminState, RootState>;
